import { combineReducers } from 'redux';

import login from './login';
import {registrationR} from './register';
import otpVerify from './loginOtpVerify';
import userNameVerify from './userNameVerify';
import verifyOTPForRegistration from './registrationOtp';
import testSeriesListInfo from './testSeries/getTestSeries';
import checkoutTestCreation from './payment';
import testSeriesTestListInfo from './testSeries/getTestSeriesTestList';
import singleTestInfo from './getSingleTestDetails';
import testTermsAndConditions from './testTermsAndConditions';
import testInfo from './startTest';
import submitTest from './submitTest';
import homeData from './home';
import currentAffairs from './currentAffairs';
import allExams from './CourseAndLibraryExam';
import coursesInfo from './courseSubjects';
import lessonPlanner from './lessonPlanner';
import courseMaterial from './courseContent';
import getHtmlContentInfo from './htmlContent';
import vimeoVideoInfo from './vimeoPlayer';
import userAuthentication from './authentication';
import testAnalysis from './result';
import librarySubjects from './librarySubjects';
import libraryTopicsBySubject from './topicLibraryDetails';
import libraryContent from './libraryContent';
import verifyEmail from './verifyEmail';
import privacyAndPolicy from './privacyAndPolicy';
import disclaimer from './disclaimer';
import aboutUs from './AboutUs';
import appTestAndTermsConditions from './appTerms&cond';
import logOut from './logout';
import { allBookMarks, addBookMark, deleteBookMark } from './bookmarkInfo/bookmarkReducers';
import currentAffairsWithPagination from './currentAffairs/listOfCurrentAffairs';
import { updateProfile, getUpdateProfile, uploadProfilePic } from './editProfile/editProfileReducer';
import changePhoneNumber from './changePhone';
import verifyChangeNumber from './changePhone/verifyChangeNo';
import JwPlayerSourceInfo from './jwPlayer';
import allTestsInfo from './getAllTestInfo';


const rootReducer = combineReducers({
    login,    
    registration: registrationR,
    // appVer,
    otpVerify,
    userNameVerify,
    testSeriesListInfo,
    testSeriesTestListInfo,
    singleTestInfo,
    testTermsAndConditions,
    testInfo,
    submitTest,
    homeData,
    currentAffairs,
    verifyOTPForRegistration,
    allExams,
    coursesInfo,
    lessonPlanner,
    courseMaterial,
    getHtmlContentInfo,
    vimeoVideoInfo,
    userAuthentication,
    testAnalysis,
    librarySubjects,
    libraryTopicsBySubject,
    libraryContent,
    verifyEmail,
    privacyAndPolicy,
    disclaimer,
    aboutUs,
    appTestAndTermsConditions,
    logOut,
    allBookMarks, 
    addBookMark, 
    deleteBookMark,
    currentAffairsWithPagination,
    updateProfile,
    getUpdateProfile,
    uploadProfilePic,
    changePhoneNumber,
    verifyChangeNumber,
    checkoutTestCreation,
    JwPlayerSourceInfo
})


export default rootReducer;